
function About() {
  return (
    <div>
      <h1 className="about-header  ">Github Finder</h1>
      <div>
        <div>
        A React app to search GitHub profiles and see profile details. This
        Project i part of the <a className="link"href="#">React Front To Back </a>
        udemy course by
        <strong>
            <a href="#" className="link"> Brad Traversy</a>
        </strong>
        </div>
        <p>
            <span style={{color:"rgba(0,0,0,0.5)"}}>Version:</span> <span>1.0.0</span>
        </p>
        <p>
            <span style={{color:"rgba(0,0,0,0.5)"}} >Layout By:</span>
            <a className="link" href="#">hassibmoddasser</a>
        </p>
      </div>
    </div>
  )
}

export default About
